<template>
    <div>
        <div v-if="loading">
            <div class="normal-container grid lg:grid-cols-2">
                <div class="relative">
                    <div
                        class="relative mb-5 w-full overflow-hidden lg:!absolute lg:left-0 lg:!mr-0 lg:mb-0 lg:max-h-[700px]">
                        <div class="lg:!flex lg:max-h-[700px] lg:justify-end">
                            <div
                                class="h-96 w-full bg-gray-200 object-cover lg:mr-20 lg:!h-[900px] lg:max-h-[700px] lg:w-8/12"></div>
                        </div>
                    </div>
                    <div class="h-max lg:!absolute lg:left-20 lg:!m-0 lg:w-24">
                        <div class="hidden !h-32 cursor-pointer lg:block lg:!h-24">
                            <div class="mb-5 !h-32 w-full bg-gray-200 object-cover lg:!h-32"></div>
                            <div class="mb-5 !h-32 w-full bg-gray-200 object-cover lg:!h-32"></div>
                            <div class="!h-32 w-full bg-gray-200 object-cover lg:!h-32"></div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="mt-10 h-[100vh] animate-pulse bg-gray-200 px-10 py-8 lg:mt-0 lg:px-28 2xl:px-32">
                        <div class="mb-4 hidden h-6 w-1/4 rounded bg-gray-300 lg:block"></div>
                        <div class="max-w-[589px] pt-10">
                            <div class="flex flex-col">
                                <div class="flex space-x-4">
                                    <div>
                                        <div class="h-24 w-24 rounded bg-gray-300"></div>
                                    </div>
                                    <div class="flex w-full flex-col space-y-2">
                                        <div class="mb-2 h-6 w-full rounded bg-gray-300"></div>
                                        <div class="mb-2 h-4 w-3/4 rounded bg-gray-300"></div>
                                        <div class="mb-8 flex">
                                            <div class="h-4 w-1/4 rounded bg-gray-300"></div>
                                            <div class="ml-3 h-4 w-1/4 rounded bg-gray-300"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4 flex space-x-4">
                                    <div class="mb-2 h-12 w-12 rounded bg-gray-300"></div>
                                    <div class="mb-2 h-12 w-12 rounded bg-gray-300"></div>
                                    <div class="mb-2 h-12 w-12 rounded bg-gray-300"></div>
                                    <div class="mb-2 h-12 w-12 rounded bg-gray-300"></div>
                                </div>
                                <div>
                                    <div class="mt-4 h-10 rounded bg-gray-300"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="LookObject" class="overflow-hidden">
                <div class="normal-container lg:grid lg:grid-cols-2 lg:gap-x-7">
                    <div class="mt-4 lg:mt-0 lg:pt-8">
                        <ShopwareProductLookImageSlider
                            :look="LookObject.look"
                            :products="productResponse"
                            layout="looks" />
                    </div>
                    <div
                        :class="{ 'mt-10': isNavigation == true }"
                        class="look-detail-products relative bg-green-300 py-6 lg:-mr-10 lg:mt-0 lg:pb-20 lg:pl-28 lg:pt-20 2xl:pl-32">
                        <div class="absolute -left-[20px] top-0 -z-10 h-full w-screen bg-green-300 lg:left-0"></div>

                        <h1 v-if="LookObject">{{ lookName }}</h1>
                        <div v-for="product in productResponse" :key="product.id" class="max-w-[589px] pt-10">
                            <div
                                v-if="product.product && parentProductResponse[product.product.parentId]?.product"
                                class="flex flex-col gap-4">
                                <div class="flex items-center gap-4">
                                    <div class="h-[125px] w-[100px]">
                                        <NuxtLink :to="'/' + product?.product?.seoUrls[0]?.seoPathInfo">
                                            <ShopwareImg
                                                :src="product.product.cover.media.url"
                                                :alt="product.product.translated.name"
                                                class="h-full w-full object-cover"
                                                :width="100" />
                                        </NuxtLink>
                                    </div>
                                    <div class="flex flex-col">
                                        <NuxtLink :to="'/' + product?.product?.seoUrls[0]?.seoPathInfo">
                                            <div class="flex flex-col font-mori text-[13px] lg:text-sm">
                                                <span class="font-semibold">{{
                                                    product.product.manufacturer.translated.name
                                                }}</span>
                                                <span>{{ product.product.translated.name }}</span>
                                            </div>
                                        </NuxtLink>
                                        <div class="flex">
                                            <p
                                                :class="{
                                                    'mr-3 text-sm line-through':
                                                        product?.product?.calculatedPrice?.listPrice?.price !==
                                                        product?.product?.calculatedPrice?.totalPrice,
                                                }">
                                                {{ useFormatPrice(product?.product?.calculatedPrice.listPrice.price) }}
                                            </p>
                                            <p
                                                v-if="
                                                    product?.product?.calculatedPrice?.listPrice?.price !==
                                                    product?.product?.calculatedPrice?.totalPrice
                                                "
                                                class="sale-tag-slim lg:!text-base">
                                                {{ useFormatPrice(product?.product?.calculatedPrice.totalPrice) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <ShopwareProductDetailAddToCart
                                        v-if="parentProductResponse[product.product.parentId]?.product"
                                        :product="parentProductResponse[product.product.parentId]?.product"
                                        :variants="product.configurator"
                                        layout="looks" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="normal-container mb-10 mt-20">
        <div class="mb-10 flex justify-center lg:justify-between">
            <h2>{{ snippets['headless.looks.discoverMoreLooks'] }}</h2>
            <NuxtLink
                :to="snippets['headless.footer.looksOverviewUrl']"
                class="hidden font-mori text-sm underline decoration-2 underline-offset-8 duration-300 hover:text-green-500 lg:block">
                {{ snippets['headless.looks.viewAllLooks'] }}
            </NuxtLink>
        </div>
        <div
            class="related-looks-component flex items-center space-x-4 overflow-x-auto lg:grid lg:grid-cols-3 lg:overflow-hidden">
            <div
                v-for="LookObject in relatedLooks"
                :key="LookObject.versionId"
                class="relative h-[230px] w-[166px] flex-shrink-0 text-center first:ml-10 last:mr-10 md:h-[350px] md:w-auto lg:first:ml-0 lg:last:mr-0 xl:h-[400px] 2xl:h-[521px]">
                <NuxtLink v-if="LookObject" class="group" :to="formattedSeoUrl(LookObject.url)">
                    <ShopwareImg
                        :src="LookObject.cover.media.url"
                        :alt="LookObject.translated.name"
                        class="h-full w-full object-cover"
                        :width="400"
                        sizes="100vw sm:50vw md:400px" />
                    <div
                        class="absolute bottom-[30px] left-1/2 w-full -translate-x-1/2 px-4 text-white lg:bottom-[90px]">
                        <p
                            v-if="LookObject.translated.name"
                            class="font-monument-extended text-lg text-sm duration-300 group-hover:text-green-600 lg:text-lg">
                            {{ LookObject.translated.name }}
                        </p>
                        <button
                            class="border-b-2 pt-2 text-center font-mori text-sm duration-300 hover:border-green-600 hover:text-green-600 group-hover:border-green-600 group-hover:text-green-600 lg:pt-4">
                            {{ snippets['headless.looks.viewLook'] }}
                        </button>
                    </div>
                </NuxtLink>
            </div>
        </div>
        <NuxtLink
            :to="snippets['headless.footer.looksOverviewUrl']"
            class="mx-auto mt-10 flex w-fit justify-center border-b-2 border-black font-mori text-sm lg:hidden">
            {{ snippets['headless.looks.viewAllLook'] }}
        </NuxtLink>
    </div>
</template>

<script setup>
    import { useProductSearch } from '@shopware-pwa/composables-next';

    const props = defineProps({
        look: Object,
    });

    const snippetsStore = useSnippetsStore();
    const snippets = snippetsStore.snippets;

    const { search } = useProductSearch();

    const loading = ref(true);
    const LookObject = ref({});
    const images = ref([]);
    const productIds = ref([]);
    const relatedLooks = ref([]);
    const productResponse = ref({});
    const parentProductResponse = ref({});

    const lookName = ref('');
    const isNavigation = ref(false);

    const fetchLook = async () => {
        const { data } = await useFetch(`/api/looks/${props.look.id}`, {
            method: 'POST',
            body: JSON.stringify({
                lookId: props.look.id,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (data.value) {
            LookObject.value = data.value;
            lookName.value = data.value.look.translated.name;

            productIds.value = data.value.look.products.map(product => product.product.id);

            for (const product of data.value.look.products) {
                search(product.product.id, {
                    criteria: {
                        associations: {
                            mainCategories: {},
                            media: {},
                            manufacturer: {
                                media: {},
                            },
                            children: {},
                            categories: {},
                            seoUrls: {},
                        },
                        configuratorSettings: true,
                    },
                }).then(response => {
                    if (response) {
                        productResponse.value[product.position] = response;
                    }
                    search(product.product.parentId, {
                        criteria: {
                            associations: {
                                mainCategories: {},
                                media: {},
                                manufacturer: {
                                    media: {},
                                },
                                children: {},
                                categories: {},
                                configuratorSettings: {},
                                seoUrls: {},
                            },
                            configuratorSettings: false,
                        },
                    }).then(parentResponse => {
                        if (parentResponse) {
                            parentProductResponse.value[product.product.parentId] = parentResponse;
                        }
                    });
                });
            }
            loading.value = false;
        }

        if (data.value.relatedLooks) {
            relatedLooks.value = data.value.relatedLooks;
        }

        if (data.value.media) {
            images.value = data.value.media;
        }
        await nextTick();
    };

    const formattedSeoUrl = url => {
        if (!url) return '';
        const segments = url.split('/');
        return `/nl/look/${segments[segments.length - 1]}`;
    };

    fetchLook();
</script>
<style scoped>
    @media (min-width: 1500px) {
        .lookLayoutContainer {
            max-width: 1712px;
            margin-left: auto;
            margin-right: auto;
            padding-left: 0;
            padding-right: 0;
        }
    }
    @media (min-width: 1024px) {
        .lookLayoutContainer {
            max-width: 1712px;
            margin-left: auto;
            margin-right: auto;
            padding-left: 40px !important;
            padding-right: 40px !important;
        }
    }
</style>
